<template>
  <f7-page no-toolbar name="vip" class="page-messgae-center" @page:init="onPageInit" style="padding-bottom: var(--f7-safe-area-bottom);"
    @page:beforein="onPageBeforeIn">
    <f7-navbar innerClass="navbar-inner-message">
      <f7-nav-left>
        <f7-link @click="back">
          <i class="f7-icons">chevron_left</i>
        </f7-link>
      </f7-nav-left>
      <f7-nav-title>VIP</f7-nav-title>
      <f7-nav-right>
        <f7-link></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <!-- <div class="head" style="position: relative;display: none;">
      <f7-block class="block-banner" style="margin:0;padding: 0;">
        <f7-swiper next-button prev-button  data-lazy="{'enabled': true}" :params="swiperParams"
          class="swiper-banner" ref="mySwiper">
          <f7-swiper-slide v-for="(item, index) in simpleVipList" :key="index">
            <div class="bg" @click="checkIndexto(index)" >
              <img :src="`../../../static/images/yt999/vip/${index+1}.png`" class="swiper-lazy"  width="45%"  />
            </div>
          </f7-swiper-slide>
        </f7-swiper>
      </f7-block>
      <div class="jie" >
        <div class="xian"></div>
        <van-tabs v-model="vandian" @click="retur()" duration="0.3">
          <van-tab v-for="(item, index) in simpleVipList" :key="index" :title="item.Name" ></van-tab>
        </van-tabs>
      </div>
      <div style="color: white;text-align: center;" v-show="depositTotalAmount"><span class="symbol" >{{ currencySymbol }}</span>{{ depositTotalAmount | formatCurrency }}</div>
    </div> -->
    
    <div class="vipcontent">
      <!-- <div class="triangle-up"></div> -->
      <div v-show="vipInfo.Remark">
        <img v-if="vipInfo.Remark == '1'" src="../../../static/images/yt999/vip/vipbg1.png" width="100%">
        <img v-else-if="vipInfo.Remark == '2'" src="../../../static/images/yt999/vip/vipbg2.png" width="100%">
        <img v-else-if="vipInfo.Remark == '3'" src="../../../static/images/yt999/vip/vipbg3.png" width="100%">
        <img v-else-if="vipInfo.Remark == '4'" src="../../../static/images/yt999/vip/vipbg3.png" width="100%">
        <div class="txt">
          <div class="s1" v-if="vipInfo.Name.length>=10" style="font-size: 20px;">{{ vipInfo.Name }}</div>
          <div class="s1" v-else>{{ vipInfo.Name }}</div>
          <div style="font-size: 18px;"><span class="symbol" >{{ currencySymbol }}</span>{{ vipInfo.DepositTotalAmount }}</div>
        </div>
      </div>

      <div class="title">
        <h3 id="tip">{{ vipInfo.Name }} {{ $t("vip_detail_0001") }}</h3>
        <!-- <h3 id="tip">{{ vipInfo.CopywriterTitle?vipInfo.CopywriterTitle:'--' }} </h3> -->
      </div>
      <!-- <div class="vipInfo">
        <div>{{ $t("vip_detail_0002") }}</div>
        <table>
          <tr>
            <td>{{ $t("vip_detail_0003") }}</td>
            <td>{{ vipInfo.OrdersRebatesRateL1 }}%</td>
          </tr>
          <tr>
            <td>{{ $t("vip_detail_0004") }}</td>
            <td>{{ vipInfo.FinancialProductRebatesRateL1 }}%</td>
          </tr>
          <tr>
            <td>{{ $t("vip_detail_0005") }}</td>
            <td>{{ vipInfo.VIPLevelUpRebatesRateL1 }}%</td>
          </tr>
        </table>
        <div>{{ $t("vip_detail_0006") }}</div>
        <table>
          <tr>
            <td>{{ $t("vip_detail_0003") }}</td>
            <td>{{ vipInfo.OrdersRebatesRateL2 }}%</td>
          </tr>
          <tr>
            <td>{{ $t("vip_detail_0004") }}</td>
            <td>{{ vipInfo.FinancialProductRebatesRateL2 }}%</td>
          </tr>
          <tr>
            <td>{{ $t("vip_detail_0005") }}</td>
            <td>{{ vipInfo.VIPLevelUpRebatesRateL2 }}%</td>
          </tr>
        </table>
        <div>{{ $t("vip_detail_0007") }}</div>
        <table>
          <tr>
            <td>{{ $t("vip_detail_0003") }}</td>
            <td>{{ vipInfo.OrdersRebatesRateL3 }}%</td>
          </tr>
          <tr>
            <td>{{ $t("vip_detail_0004") }}</td>
            <td>{{ vipInfo.FinancialProductRebatesRateL3 }}%</td>
          </tr>
          <tr>
            <td>{{ $t("vip_detail_0005") }}</td>
            <td>{{ vipInfo.VIPLevelUpRebatesRateL3 }}%</td>
          </tr>
        </table>
      </div> -->
      <h4 style="margin: 0 0 4px 0;">{{ $t("vip_detail_0019") }}</h4>
      <table class="custom-table">
        <thead>
          <tr>
            <th>{{ $t("vip_detail_0020") }}</th>
            <th>{{ $t("vip_detail_0021") }}</th>
            <th>{{ $t("vip_detail_0022") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ $t("vip_detail_0023") }}</td>
            <td>{{ vipInfo.DailyOrderCountLimit }}</td>  
            <td>{{ (vipInfo.DailyOrderCountLimit*vipInfo.FixedProfitAmount) | formatCurrency }}</td>
          </tr>
          <tr v-show="vipInfo.VIPValidDays>=30">
            <td>{{ $t("vip_detail_0024") }}</td>
            <td>{{ vipInfo.DailyOrderCountLimit*30 }}</td>
            <td>{{ (vipInfo.DailyOrderCountLimit*30*vipInfo.FixedProfitAmount) | formatCurrency }}</td>
          </tr>
          <tr v-show="vipInfo.VIPValidDays>=30">
            <td>{{ $t("vip_detail_0025") }}</td>
            <td>{{ vipInfo.DailyOrderCountLimit*365 }}</td>
            <td>{{ (vipInfo.DailyOrderCountLimit*365*vipInfo.FixedProfitAmount) | formatCurrency }}</td>
          </tr>
        </tbody>
      </table>
      <h4 style="margin: 15px 0 4px 0;">{{ $t("vip_detail_0026") }}</h4>
      <table class="custom-table">
        <thead>
          <tr>
            <th>{{ $t("vip_detail_0027") }}</th>
            <th>{{ $t("vip_detail_0028") }}</th>
            <th>{{ $t("vip_detail_0029") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ $t("vip_detail_0030") }}</td>
            <td>{{ vipInfo.VIPLevelUpRebatesRateL1 }}%</td>
            <td>{{ (vipInfo.VIPLevelUpRebatesRateL1*vipInfo.DepositTotalAmount/100) | formatCurrency }}</td>
          </tr>
          <tr>
            <td>{{ $t("vip_detail_0031") }}</td>
            <td>{{ vipInfo.VIPLevelUpRebatesRateL2 }}%</td>
            <td>{{ (vipInfo.VIPLevelUpRebatesRateL2*vipInfo.DepositTotalAmount/100) | formatCurrency }}</td>
          </tr>
          <tr>
            <td>{{ $t("vip_detail_0032") }}</td>
            <td>{{ vipInfo.VIPLevelUpRebatesRateL3 }}%</td>
            <td>{{ (vipInfo.VIPLevelUpRebatesRateL3*vipInfo.DepositTotalAmount/100) | formatCurrency }}</td>
          </tr>
        </tbody>
      </table>
      <h4 style="margin: 15px 0 4px 0;">{{ $t("vip_detail_0033") }}</h4>
      <table class="custom-table">
        <thead>
          <tr>
            <th>{{ $t("vip_detail_0034") }}</th>
            <th>{{ $t("vip_detail_0035") }}</th>
            <th>{{ $t("vip_detail_0036") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ $t("vip_detail_0037") }}</td>
            <td>{{ vipInfo.OrdersRebatesRateL1 }}%</td>
            <td>{{ (vipInfo.OrdersRebatesRateL1*vipInfo.FixedProfitAmount*vipInfo.DailyOrderCountLimit/100) | formatCurrency }}</td>
          </tr>
          <tr>
            <td>{{ $t("vip_detail_0038") }}</td>
            <td>{{ vipInfo.OrdersRebatesRateL2 }}%</td>
            <td>{{ (vipInfo.OrdersRebatesRateL2*vipInfo.FixedProfitAmount*vipInfo.DailyOrderCountLimit/100) | formatCurrency }}</td>
          </tr>
          <tr>
            <td>{{ $t("vip_detail_0039") }}</td>
            <td>{{ vipInfo.OrdersRebatesRateL3 }}%</td>
            <td>{{ (vipInfo.OrdersRebatesRateL3*vipInfo.FixedProfitAmount*vipInfo.DailyOrderCountLimit/100) | formatCurrency }}</td>
          </tr>
        </tbody>
      </table>

      <!-- <div v-html="vipInfo.CopywriterContent?vipInfo.CopywriterContent:'---'"></div> -->
    </div>
    <div style="position: fixed;width: 100%;text-align: center;bottom: 25px;">
      <!-- <f7-button round outline class="buyVip" v-if="!vipInfo.EnableVIPLevelUpdate" style="background: #ccc;">{{ $t("vip_detail_0040") }}</f7-button> -->
      <f7-button round outline class="buyVip" @click="showPopup()" v-if="myDepositTotalAmount < vipInfo.DepositTotalAmount">{{ $t("vip_detail_0008") }}</f7-button>
    </div>
    <div style="height: 55px;"></div>

    <van-popup v-model="vantshow" position="bottom"   class="vanbuy">
      <div class="sheet-modal-swipe-step">
        <div class="display-flex justify-content-space-between align-items-center buypopup">
          <div class="yiban one">
            <div style="font-size: 18px;line-height: 37px;">{{ $t("vip_detail_0010") }}</div>
            <div style="position: relative;text-align: right;">
              <span class="go" @click="topUp()">{{ $t("financial_detail_0033") }}</span>
            </div>
          </div>
          <div class="paddding" style="font-size: 18px;">{{ $t("vip_detail_0012") }} {{ vipInfo.Name }}</div>
          <div class="yiban two paddding">
            <div style="color:#707070 ;">{{ $t("vip_detail_0013") }} {{ vipInfo.VIPAmountLockDays }}</div>
          </div>

          <div class="paddding" style="">
            <div style="color:#707070 ;">{{ $t("activity_0051") }}</div>
            <div class="money2">
              <div :class="moneyType==1?'active':''" @click="moneyType=1" v-show="vipInfo.EnablePurchaseFromMainAccountBalance">
                <div>{{ $t("member_center_0046") }}{{ $t("member_center_0071") }}</div>
                <div class="font13"><span class="symbol">{{ currencySymbol }}</span> {{ memberBalance | formatCurrency }}</div>
              </div>
              <div :class="moneyType==2?'active':''" @click="moneyType=2" v-show="vipInfo.EnablePurchaseFromInvestmentAccountBalance">
                <div>{{ $t("member_center_0068") }}{{ $t("member_center_0071") }}</div>
                <div class="font13"><span class="symbol">{{ currencySymbol }}</span> {{ investmentAccountBalance | formatCurrency }}</div>
              </div>
            </div>
          </div>

          <div class="yiban three paddding">
            <div style="color:#707070 ;">{{ $t("vip_detail_0014") }}</div>
            <div style="color:#0887b2 ;"><span class="symbol">{{ currencySymbol }}</span>{{ vipInfo.DepositTotalAmount | formatCurrency }}</div>
          </div>
          <div class="yiban four paddding price" >
            <div><span>{{ $t("vip_detail_0016") }}</span>
            <span style="color: #0887b2;font-size: 18px;">{{ currencySymbol }}&nbsp;{{vipInfo.DepositTotalAmount | formatCurrency}}</span></div>
            <div class="paybtn" @click="vipLevelUpdateMethod(vipInfo)">{{ $t("vip_detail_0017") }}</div>
          </div>
          <!-- <div style=" height:calc(var(--f7-safe-area-bottom) + 55px);"></div> -->
        </div>
      </div>
    </van-popup>

  </f7-page>
</template>

<script>
import { getCookie,getStore } from "@/config/utils";
import { getUserInfo, getBalancesDetail, logout, checkBonusPointWallet, userNameSignindetailDay, getsimpleviplist, vipLevelUpdate } from "../../../axios/api";
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  components: {},
  props: {},
  data() {
    const self = this;
    return {
      currencySymbol: '',
      simpleVipList: [],
      vipInfo: {
        Name: ''
      },
      myVIPLevelUpRebatesRateL: [],
      memberBalance: 0,
      checkIndex: -1,
      swiperParams: {
        speed: 700,
        initialSlide: 0,  // 默认显示第几块
        lazy: {
          loadPrevNext: true,
        },
        loop: false,
        spaceBetween: 10,
        slidesPerView: 'auto',
        centeredSlides: true,
        // allowTouchMove: false,  // 禁用滑动
        pagination: {
          clickable: true,  // 启用分页点击
        },
        on: {
          slideChangeTransitionEnd: function () {
            self.activeSimpleVip(this.activeIndex);
            self.updateAm(this.activeIndex);
            
          },
        },
      },
      mySheetOpened: true,
      vantshow: null,
      vandian: 0,
      num : 0,
      depositTotalAmount: 0,
      myDepositTotalAmount: 0,
      userInfo:{},
      moneyType: 1,
      investmentAccountBalance: 0,
    };
  },
  watch: {
    // 滑动
    // checkIndex(newData, oldData) {
    //   this.updateAm(this.checkIndex);
    //   this.$refs.mySwiper.swiper.slideTo(this.checkIndex, 1000);   // mySwiper对象名是通过 ref定义的
    // }

  },
  computed: {
    ...mapGetters([ "getLoginInfo", "getLoginState"]),

  },
  methods: {
    ...mapActions(["saveLoginState"]),

    retur(){
      this.activeSimpleVip(this.vandian);
      this.updateAm(this.vandian);
      this.$refs.mySwiper.swiper.slideTo(this.vandian, 1000);
    },
    onPageInit() {
      this.$f7.emit("myCustomEvent", "vip");
      this.getsBalancesDetail();
    },
    showPopup() {
      this.vantshow = true;
    },
    //点击
    checkIndexto(id) {
      this.checkIndex = id;
      this.updateAm(id);
      // this.$refs.mySwiper.swiper.slideTo(id, 1000);   // mySwiper对象名是通过 ref定义的
    },
    updateAm(id){
      this.vandian = id;
      this.checkIndex = id;
      this.depositTotalAmount = this.simpleVipList[id].DepositTotalAmount;


      this.simpleVipList.forEach((item, index) => {
        const dom = document.getElementById('am'+index);
        if(dom==null) return;
        if(id==index){
          // dom.innerHTML = this.currencySymbol+'<br/>'+this.$options.filters.formatCurrency( this.simpleVipList[index].DepositTotalAmount) ;
          dom.innerHTML = this.$options.filters.formatCurrency( this.simpleVipList[index].DepositTotalAmount) ;
          // dom.style.fontSize = '14px';
          dom.style.right = '10px';
        }else{
          dom.innerHTML = this.simpleVipList[index].Name;
          // dom.style.fontSize = '16px';
          dom.style.right = '20px';
        }
      });
    },

    vipLevelUpdateMethod(item) {
      const self = this;
      self.vantshow = false;
      const params = {
        TargetVIPLevelID: item.Id,
        OrderModel: this.moneyType == 1 ? 1 : 2   
      };
      let d = { data: JSON.stringify(params) };
      vipLevelUpdate(d).then((data) => {
        if (data.Code === "NoError") {
          self.logout(1, data);
          
        }else if(data.Code == 'BalanceNotEnough'){
          self.$f7.dialog.create({
          title: this.$t(""),
          text:  data.Data,
          cssClass: "dialog-logout",
          buttons: [
            {
              text: this.$t("common_0001"),
              cssClass: "dialog-ok",
              onClick: () => {
                self.$f7.sheet.close();
                self.$f7.$(".dialog-backdrop").css("background", "transparent");
              },
            },
            {
              text: this.$t("vip_detail_0042"),
              cssClass: "dialog-ok",
              onClick: () => {
                self.$f7.sheet.close();
                self.$f7.$(".dialog-backdrop").css("background", "transparent");
                self.$f7router.navigate("/member-center/deposit/"+item.DepositTotalAmount+"/");
              },
            }
          ],
        }).open();
        } else {
          self.logout(2, data.Data);
        }

      });
    },
    getUserInfoEvent() {
      getUserInfo().then((data) => {
        if (data.Code === "NoError") {
          this.userInfo = data.Data;
          this.getSimpleVipList();

        }
      });
    },
    getSimpleVipList() {
      const self = this;
      const vipLevel = this.$f7route.params.vipLevel;
      const params = {"ShowDefault":true};
      let d = JSON.stringify(params);

      getsimpleviplist(d).then((data) => {
        if (data.Code === "NoError") {
          self.simpleVipList = data.Data;
          data.Data.forEach((item, index) => {
            // item.Name = item.Name.toUpperCase();
            item.CopywriterTitle = self.simpleVipList[0].CopywriterTitle;
            item.CopywriterContent = self.simpleVipList[0].CopywriterContent;
            if (item.Id == vipLevel) {
              self.checkIndex = index;
              self.vipInfo = item;
              this.moneyType = item.EnablePurchaseFromMainAccountBalance?1:2;
              
            }
            if (item.Id == self.userInfo.VipLevel) {
              self.myDepositTotalAmount = item.DepositTotalAmount;
            }
          });
          if (self.checkIndex == -1) {
            self.vipInfo = self.simpleVipList[0];
            setTimeout(() => {
              self.checkIndex = 0;
            }, 500);
          }
        }
      });
    },

    getsBalancesDetail() {
      getBalancesDetail().then((data) => {
        if (data.Code === "NoError") {
          const res = data.Data;
          this.memberBalance = data.Data.Balance;
          this.investmentAccountBalance = data.Data.InvestmentAccountBalance;
        }
      });
    },

    activeSimpleVip(index) {
      this.vipInfo = this.simpleVipList[index];
    },

    topUp() {
      this.$f7.sheet.close();
      this.$f7router.navigate("/member-center/deposit/");
    },

    onPageBeforeIn() {
      this.$f7.tab.show("#tab-user-message");
      //}
    },
    back() {
      this.$f7router.back();
    },

    // 弹窗
    logout(paramInt, data) {
      const self = this;
      const showtext = '';
      self.$f7.$(".dialog-backdrop").css("background", "rgba(0, 4, 7, 0.77)");
      if (paramInt == 1) {
        if(data.Data.BonusForFirstTimeBecomeVIP_Show){
          self.showtext = `<div><span style="font-weight: bold;">` + this.$t("vip_detail_0018") + `&nbsp;` + self.vipInfo.Name + `</span><br><span style="font-size:14px">` + this.$t("bonusv0_01") + `</span><br><span style="color:red;font-size:18px;font-weight:bold;">`+self.currencySymbol+' '+data.Data.BonusForFirstTimeBecomeVIP_Amount+`</span><br><span style="font-size:14px">` + this.$t("bonusv0_02") + `</span><br></div>`;
          // self.showtext = `<div><img src="../../../static/images/yt999/home/ico/ZZicon/vip_${self.checkIndex}.png" style="width: 50%;"><br/><span style="font-weight: bold;">` + this.$t("vip_detail_0018") + `&nbsp;` + self.vipInfo.Name + `</span><br><span style="font-size:14px">` + this.$t("bonusv0_01") + `</span><br><span style="color:red;font-size:18px;font-weight:bold;">`+self.currencySymbol+' '+data.Data.BonusForFirstTimeBecomeVIP_Amount+`</span><br><span style="font-size:14px">` + this.$t("bonusv0_02") + `</span><br></div>`;
        }else{
          self.showtext = `<div><span style="font-weight: bold;">` + this.$t("vip_detail_0018") + `&nbsp;` + self.vipInfo.Name + `</span></div>`;
          // self.showtext = `<div><img src="../../../static/images/yt999/home/ico/ZZicon/vip_${self.checkIndex}.png" style="width: 50%;"><br/><span style="font-weight: bold;">` + this.$t("vip_detail_0018") + `&nbsp;` + self.vipInfo.Name + `</span></div>`;
        }
      } else {
        self.showtext = data;
      }
      self.$f7.dialog.create({
        title: this.$t(""),
        text: this.showtext,
        cssClass: "dialog-logout",
        buttons: [
          {
            text: this.$t("common_0001"),
            cssClass: "dialog-ok",
            onClick: () => {
              self.$f7.sheet.close();
              self.$f7.$(".dialog-backdrop").css("background", "transparent");
              if (paramInt == 1) {     //升级成功更新下界面
                // this.getUserInfo();   //更新顶部会员信息
                // this.getsBalancesDetail();   //更新钱包余额
                self.$f7router.navigate(`/member-center/vip-list/${self.userInfo.VipLevel}/`)
              }
            },
          },
        ],
      }).open();
    },
  },
  created() {
    this.currencySymbol = getStore('currencySymbol');
    this.getUserInfoEvent();

  },
  mounted() {
  },
};
</script>
<style lang="less" scoped>
// ::v-deep .navbar-inner{    //头部颜色更换
//   color: white;
//   background: linear-gradient(to right, var(--f7-THEME-color), var(--f7-THEME-color));
// }
// ::v-deep .page-content{
//   padding-top: 0;
// }
.head {
  // background: #0887b2;
  width: 100%;
  background: url(../../../static/images/yt999/vip/bg.png)  ;
  background-size: 100% 100%;
  height: 230px;
  text-align: center;
  padding-top: 15px;
  .bg{
    margin-top: 58px;
  }
  .jie{
    // height: 80px;
    position: relative;
  }
  .xian{
    background: linear-gradient(to right, rgba(0, 139, 114, 0.5), rgba(0, 139, 114, 1));
    width: 100%;
    height: 3px;
    position: absolute;
    bottom: 5px;
    z-index: 0;
  }
  .gai{
    position: absolute;
    width: 100%;
    height: 50px;
    bottom: 0px;
    z-index: 11;
  }
  .swiper-container{
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 1;
    // padding-bottom: 30px;
    ::v-deep .swiper-pagination-bullet-active {
      opacity: 1;
      background: var(--f7-THEME-color);
    }
    
  }
  ::v-deep .swiper-pagination-bullet{
      width: 10px;
      height: 4px;
      display: inline-block;
      border-radius: 40%;
      background: #000;
      opacity: 0.2;
    }
  .swiper-slide {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      margin: 0 auto;
      
    }
  }

  .amount {
    // color: #e3e3e3d6;
    position: absolute;
    right: 10px;
    bottom: 10px;
    text-align: center;
    font-size: 12px;
  }

  .vipname {
    // color: #e3e3e3d6;
    position: absolute;
    left: 20px;
    bottom: 10px;
    font-size: 12px;

  }

}


.vipcontent {
  width: 90%;
  margin: 0 auto;
  position: relative;
  padding-bottom: 10px;
  padding-top: 15px;
  .txt{
    position: absolute;
    top: 35px;
    right: 28%;
    width: 100%;
    text-align: right;
    color: #004b86;
    .s1{
      font-size: 30px;
      font-weight: bold;
    }
  }
  .triangle-up {
    position: absolute;
    left: 45%;
    top: -27px;
    width: 0;
    height: 0;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    border-bottom: 15px solid white;
    z-index: 10;
  }
  .title {
    position: relative;
    padding-left: 7px;

    #tip {
      padding-left: 6px;
    }

    #tip:before {
      content: '';
      position: absolute;
      top: 4px;
      left: 0px;
      transform: translateX(-50%);
      width: 3px;
      height: 16px;
      background-color: var(--f7-THEME-color);
    }
  }

  .vipInfo {
    div {
      margin-bottom: 5px;
      padding-bottom: 5px;
      font-size: 15px;
      font-weight: bold;
      border-bottom: 1px solid #e3e3e3;
      margin-top: 10px;
    }

    table {
      display: block;
      color: #696969;

      tr {
        display: flex;

        td {
          width: 50%;
          margin-bottom: 5px;
        }

        td:nth-child(2) {
          text-align: right;
        }
      }
      
    }
  }

.custom-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
    padding: 5px;
    font-size: 12px;
    head{
      background-color: #ddd;
     
    }
    th, td {
      text-align: center;
      border: 1px solid #d6d6d6; /* 设置边框颜色和样式 */
      padding: 0 2px;
    }
    tr{
      // border-bottom: 1px solid #ddd;
      height: 30px;
      line-height: 30px;
      th {
        background-color: #f2f2f2;
        font-weight: 400;
        line-height: normal;
      }
      th:nth-child(3) {
      }
      td:nth-child(1) {
        width: 50%;
        line-height: 16px;
      }
      td:nth-child(2) {
      }
      td:nth-child(3) {
      }
    } 
  }
}

.buyVip {
  background: var(--f7-THEME-color);
  width: 80%;
  height: 40px;
  line-height: 40px;
  color: white;
  text-align: center;
  border-radius: 7px;
  margin: 0 auto;
  margin-top: 30px;
  border: 0px;
}

.user-level {
  position: absolute;
  top: 0px;
  left: 0px;

  img {
    width: 66px;
    height: 18px;
    position: absolute;
    left: 0px;
    top: 0px;
  }

  span {
    color: #fff;
    position: absolute;
    top: 0px;
    font-style: italic;
    font-weight: 400;
    font-size: 13px;
    line-height: 18px;
    left: 20px;
  }
}

.buypopup {
  display: block !important;
  padding: 0px !important;
  font-size: 12px;
  #add {
    position: absolute;
    right: 25px;
    top: 5px;
    font-size: 23px;
  }
  .yuer{
    width: 100%;
    position: absolute;
    right: 60px;
  }
  .yiban {
    display: flex;
 
    div {
      width: 50%;
    }
    div:nth-child(1) {
      width: 40%;
    }

    div:nth-child(2) {
      width: 70%;
    }
  }

  .paddding {
    padding: 10px;
    margin: 10px;
    padding: 5px;
    border-bottom: 1px solid #e1e0e0;

    .money2{
      display: grid ;
      grid-template-columns: 1fr 1fr ;
      grid-gap: 10px;
      margin-bottom: 5px;
      >div{
        border: 1px solid rgb(232, 232, 232);
        border-radius: 5px;
        padding: 7px;
        text-align: left;
        >div:nth-child(1){
          font-size: 11px;
        }
      }
      .font13{
        font-size: 13px;
        text-align: left;
      }
      .active{
        border: 1px solid var(--f7-THEME-color);
        background-color: var(--f7-THEME-color2);
      }
    }

    >div:nth-child(2) {
      text-align: right;
    }
  }
  .price{
    span {
      width: 50px;
      height: 20px;
      display: block;
      text-align: center;
      line-height: 20px;
      border-radius: 10px;
      border: 1px solid var(--f7-THEME-color);
      margin: 0px 3px;
    }

  }
  .one {
    background: var(--f7-THEME-color);
    color: white;
    padding: 11px 0 7px 28px;
    .go{
      background: #0f617d;
      padding: 5px 10px;
      border-radius: 5px;
      margin: 8px 20px 0 0;
      position: relative;
      top: 9px;
      right: 5px;
    }
  }

  .four {
    border: none;
    padding: 10px 0 13px 20px;

    span {
      border: none;
    }
  }

  .paybtn {
    text-align: center !important;
    line-height: 36px;
    border-radius: 20px;
    background: var(--f7-THEME-color);
    height: 36px;
    color: #ffffff;
    font-size: 16px;
    width: 113px !important;
    margin-left: 25%;
    margin-top: 3px;
  }
}
.vanbuy{
  border-radius: 20px 20px 0 0;
  // padding-bottom: 55px;
}
::v-deep .van-tabs__nav{
  background: none;
}
::v-deep .van-tabs__wrap--scrollable .van-tab{
    -webkit-box-flex: 1;
    -webkit-flex: 1 0 auto;
    flex: 1 0 auto;
    padding: 0px 33px;
    color: #fff;
    position: relative;
    font-size: 12px;

    ::after{
      content: '';
      width: 10px;
      height: 10px;
      background-color: #046e5c;
      border-radius: 50%;
      position: absolute;
      bottom: 2px;
      left: 35px;
      z-index: 10;
    }
    // span{
    //   width: 10px;
    //   height: 10px;
    //   background-color: #fff;
    //   border-radius: 50%;
    // }
}
::v-deep .van-tabs__line{
  position:absolute;
  background: #ffe600;
  border: 3px solid orange;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  z-index: 11;
}
::v-deep .van-tabs--line .van-tabs__wrap{
  // height: 10px;
  // background: #e03c21;
}
</style>
